export default "__VITE_ASSET__C6ehu3sH__"